<template lang="pug">
.pa-3
  v-card.mx-auto(elevation='1')
    v-toolbar(
      flat='',
      dense
    )
      v-toolbar-title.font-weight-700.font-size-12  Nuevo ticket de garantia
      v-spacer
    v-divider
    .box-new-ticket.pa-3
      v-slide-group(
        v-model='ticket.comproAqui'
        mandatory
        show-arrows=''
      )
        v-slide-item.animated.fadeInLeft.faster(
          v-for='(n, index) in acciones'
          :value="n.value"
          :key='index'
          v-slot='{ active, toggle }'
        )
          v-card.elevation-1.ma-1.d-flex.ai-center.jc-center.text-center.pa-2(
            :color="active ? 'primary' : 'secondary primary--text'"
            height='60',
            :dark="active"
            width='140'
            @click='toggle'
          )
            span.font-size-13.font-weight-700 {{n.name}}
      .mt-2(v-if="ticket.comproAqui === 1")
        v-checkbox( hide-details v-model='ticket.sigueEnGarantia' label='¿Tu equipo se encuentra en garantia?')
      .mt-2(v-if="ticket.comproAqui && ticket.sigueEnGarantia")
        v-alert.mt-4(
          icon='info'
          text
          dense
          type='info'
        )
          .d-flex.fd-column
            span.font-size-13.font-weight-700 Es requerido adjuntar la Boleta o Factura para verificar la garantia, use la opción de adjuntar que se encuentra en la parte inferior de este formulario.
      .mt-2(v-if="ticket.comproAqui === 1")
        v-text-field.mt-6( hide-details v-model='ticket.numeroFactura' dense ref="numeroFactura"  type="text" :label="`Numero de boleta o factura ${ !ticket.sigueEnGarantia ? '(Opcional)' : ''}`")
      .mt-2
        small.font-size-11  ¿Que tipo de equipo posee?
        v-select.mt-1(
          :loading="isGettingTiposEquipo"
          dense,
          hide-details
          v-model='ticket.tipoEquipo'
          :items='tiposEquipo'
          return-object
          item-text="descripcion"
          :placeholder="`Listados de tipos de equipos`"
          solo,
          @change="fetchFallas"
        )
      .pt-2
        small.font-size-11  ¿Que esta fallando?
        v-select.mt-2(
          :loading="isGettingFallas"
          dense,
          hide-details
          return-object
          item-value="codigoFallaGeneral"
          item-text="descripcionFallaGeneral"
          v-model='ticket.falla'
          :items='fallas'
          :placeholder="`Listado de fallas para la serie ${ticket.serie}`"
          solo
        )
        v-alert.mt-4(
          icon='info'
          outlined text='',
          dense
          type='warning'
        )
          .d-flex.fd-column
            span.font-size-14.font-weight-700 Explicanos un poco más de la falla de tu equipo
            span.font-size-11  Ejemplos
            small.font-size-11  - La parte superior izquierda de la hoja sale manchada de rojo
            small.font-size-11  - Si el equipo mostrara un código de error, por favor ingreselo aquí
        v-textarea.mt-3(
          v-model='ticket.comentarioFalla'
          placeholder='Comentario adicional sobre la falla (opcional)'
          solo,
          dense,
          rows="3"
        )
      .d-flex.my-4.mx-2(:class="isMovil && 'fd-column'")
        .flex-1
          v-select(
            dense
            v-model='ticket.marca'
            :items='marcas'
            label="Marca del equipo (Opcional)"
            item-text="descripcion"
            item-value="descripcion"
            hide-details
          )
        .flex-1( :class="!isMovil && 'px-6'" v-if="ticket.tipo === 'garantia'")
          v-text-field(  v-model='ticket.modelo' dense  type="text" label='Modelo del equipo o factura (Opcional)' )
        .flex-1(v-if="ticket.tipo === 'garantia'")
          v-text-field(  v-model='ticket.serie' dense  type="text" label='Serie del equipo o factura (Opcional)' )
      v-row.my-2(v-if="ticket.tipo === 'garantia'")
        v-col(cols="12" md='3')
          .d-flex
              v-text-field(v-model='ticket.ubigeo' dense=''  label='Ubigeo' type="number", :loading="isLoadingUbigeos" @keyup.enter="fetchUbigeos(true)",  hide-details)
              v-tooltip(top='')
                template(v-slot:activator='{ on, attrs }')
                  v-btn.ml-4(fab, color="primary" small v-bind='attrs' v-on='on' :disabled="isLoadingUbigeos || !ticket.ubigeo"  @click="fetchUbigeos(true)")
                    v-icon search
                small Obtener ubigeo
        v-col(cols="12" md='3')
          v-autocomplete(v-model='ticket.departamento' :items='departamentos' @change="rellenarInformacion('departamento')"  dense=''  label='Departamento'  hide-details)
        v-col(cols="12" md='3')
          v-autocomplete(v-model='ticket.provincia' :items='provincias'  dense='' @change="rellenarInformacion('provincia')"  label='Provincia'   hide-details)
        v-col(cols="12" md='3')
          v-autocomplete(v-model='ticket.distrito' :items='distritos'  dense=''  @change="rellenarInformacion('distrito')"  label='Distrito'  hide-details)
      .pt-0
        small.font-size-11  ¿Alguna observación adicional?
        v-textarea.ma-1.mt-3(
          hide-details,
          v-model='ticket.comentarioGeneral'
          placeholder='Comentario general  (Opcional)'
          solo,
          dense,
          rows="3"
        )
      .pt-0(v-if="ticket.tipo === 'garantia'")
        small.font-size-11  Adjuntar sustento a la solicitud (Boleta, Guia o Factura de compra)
        adjuntar-archivos(
          ref="archivos",
          mode-insert
        )
    v-divider
    .d-flex.pa-3
      v-spacer
      v-btn(
        color="success",
        @click="fetchGuardarTicket",
        :small="!isMovil",
        :block="isMovil"
      )
        | Generar ticket
</template>

<script>
import Router from '../router/customer.js'
import { apiGet, apiPost, apiUploadWithParams, notify } from '../util/general'
import adjuntarArchivos from './c_adjuntar_archivos'
export default {
  name: 'nuevo_ticket',
  components: {
    'adjuntar-archivos' : adjuntarArchivos
  },
  data () {
    return {
      isContrato           : false,
      isGettingFallas      : false,
      fallas               : [],
      isSuccessfullyCreated: false,
      isGettingTiposEquipo : false,
      tiposEquipo          : [],
      marcas          : [],
      files                : [],
      filesUploads         : [],
      tiposInforme         : [
        {
          name : 'Mantenimiento Preventivo',
          value: 1
        },
        {
          name : 'Falla en el equipo',
          value: 2
        },
        {
          name : 'Otros',
          value: 3
        }
      ],
      acciones         : [
        {
          name : 'He comprado mi equipo aqui',
          value: 1
        },
        {
          name : 'No he comprado el equipo aqui',
          value: 0
        }
      ],
      ticket : {
        tipo             : 'garantia',
        tipoInforme      : 1,
        serie            : '',
        falla            : {},
        comentarioFalla  : '',
        comentarioGeneral: '',
        files            : [],
        sigueEnGarantia  : false,
        numeroFactura    : '',
        tipoEquipo       : {},
        marca            : '',
        modelo           : '',
        comproAqui       : 1,
        departamente     : '',
        provincia        : '',
        distrito         : '',
        ubigeo           : '',
        categoria        : 'garantia'
      },
      perfilUsuario         : localStorage.getItem('perfil'),
      departamentos         : [],
      provincias            : [],
      distritos             : [],
      ubigeos               : [],
      isLoadingDepartamentos: false,
      isLoadingProvincias   : false,
      isLoadingDistritos    : false,
      isLoadingUbigeos      : false
    }
  },
  created () {
    var vm = this
    vm.fetchUbigeos(false, err => {
      if (err) notify(vm, 'error', 'Error', 'Ingrese un numero de RUC')
    })
    vm.fetchGetDataMarcas()
    vm.fetchTiposEquipo()
  },
  watch : {
    'ticket.tipo' : function (tipo) {
      var vm = this
      if (tipo === 'garantia') {
        vm.fetchTiposEquipo()
      }
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    fetchFallas (tipoEquipo) {
      console.log('tipoEquipo', tipoEquipo)
      var vm = this
      vm.isGettingFallas = true
      var obj = {
        codigoTipoEquipo: tipoEquipo.codigo
      }
      apiGet(vm, '/falla/por/tipo/equipo', obj, function (data) {
        vm.fallas = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isGettingFallas = false
      })
    },
    fetchGetDataMarcas () {
      var vm  = this
      var obj = {
        octopus: true
      }
      apiGet(vm, '/articulo/marca-articulo', obj, function (data) {
        vm.marcas = data.lista
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    rellenarInformacion (tipo) {
      var vm = this
      if (tipo === 'departamento') {
        vm.provincias = []
        vm.ticket.provincia = ''
        vm.distritos  = []
        vm.ticket.distrito = ''
      } else if (tipo === 'provincia') {
        vm.distritos  = []
        vm.ticket.distrito = ''
      }

      for (var i = 0; i < vm.ubigeos.length; i++) {
        if (tipo === 'departamento') {
          if (vm.ticket.departamento === vm.ubigeos[i].departamento) {
            vm.provincias.push(vm.ubigeos[i].provincia)
          }
        } else if (tipo === 'provincia') {
          if (vm.ticket.provincia === vm.ubigeos[i].provincia) {
            vm.distritos.push(vm.ubigeos[i].distrito)
          }
        }
      }

      if (vm.ticket.departamento && vm.ticket.provincia && vm.ticket.distrito) {
        vm.ticket.ubigeo = vm.ubigeos.find(e => e.descripcion === `${vm.ticket.departamento}-${vm.ticket.provincia}-${vm.ticket.distrito}`).ubigeo
      } else vm.ticket.ubigeo = ''
    },
    fetchUbigeos (ingresoUbigeo, callback) {
      var vm  = this
      vm.isLoadingUbigeos = true
      var obj = {
        codigo: vm.ticket.ubigeo
      }
      apiGet(vm, '/ubigeo/obtener', obj, function (data) {
        if (ingresoUbigeo) {
          var lista = data.lista[0]
          for (var j = 0; j < vm.ubigeos.length; j++) {
            if (lista.departamento === vm.ubigeos[j].departamento) {
              vm.provincias.push(vm.ubigeos[j].provincia)
            }

            if (lista.provincia === vm.ubigeos[j].provincia) {
              vm.distritos.push(vm.ubigeos[j].distrito)
            }
          }
          vm.ticket.departamento = lista.departamento
          vm.ticket.provincia    = lista.provincia
          vm.ticket.distrito     = lista.distrito
        } else {
          vm.ubigeos = data.lista
          for (var i = 0; i < data.lista.length; i++) {
            vm.departamentos.push(data.lista[i].departamento)
          }
        }
        callback && callback()
      }, function (error) {
        callback ? callback(error) :  notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingUbigeos = false
      })
    },
    goTo (page) {
      Router.push(page)
    },
    // fetchFallas () {
    //   var vm = this
    //   vm.isGettingFallas = true
    //   var obj = {
    //     codigoTipoEquipo: vm.ticket.tipoEquipo.codigo
    //   }
    //   apiGet(vm, '/falla_tipo_equipo/lista', obj, function (data) {
    //     vm.fallas = data.lista
    //   }, function (error) {
    //     notify(vm, 'error', 'Error', error.message)
    //   }, function () {
    //     vm.isGettingFallas = false
    //   })
    // },
    async fetchGuardarTicket () {
      var vm = this
      if (vm.ticket.tipo === 'garantia' && vm.ticket.sigueEnGarantia &&  !vm.ticket.numeroFactura && vm.ticket.comproAqui) {
        notify(vm, 'error', 'Error', 'Por favor Ingrese el numero de factura o boleta')
        vm.$refs.numeroFactura.focus()
        return;
      }

      if (vm.ticket.tipo === 'garantia' && !Object.keys(vm.ticket.tipoEquipo).length) {
        notify(vm, 'error', 'Error', 'Por favor seleccione un tipo de equipo')
        return;
      }

      if (vm.ticket.tipo === 'garantia' && !Object.keys(vm.ticket.falla).length) {
        notify(vm, 'error', 'Error', 'Por favor seleccione una falla')
        return;
      }

      vm.ticket.sigueEnGarantia = vm.ticket.sigueEnGarantia ? 1 : 0
      vm.files = await vm.$refs.archivos.getFiles()
      if (vm.ticket.tipo === 'garantia' && vm.ticket.comproAqui && vm.ticket.sigueEnGarantia && !vm.files.length) {
        notify(vm, 'error', 'Error', 'Es requerido adjuntar la boleta o factura, use la opción de adjuntar que se encuentra en la parte inferior de este formulario.')
        return;
      }

      vm.$store.dispatch('transaccion', {isProceso : true, message : 'Generando ticket'})
      var obj = {
        ticket : vm.ticket
      }

      apiPost(vm, '/ticket/registrar', obj, function (data) {
        if (data.numero) {
          vm.ticket.numero = data.numero
          if (vm.files.length) vm.fetchUploadsFiles()
          else {
            notify(vm, 'success', 'Exito', 'El ticket se creo correctamente')
            vm.goTo(`/ticket/${vm.ticket.numero}`)
          }
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    setearSerie (equipo) {
      var vm = this
      vm.ticket.serie      = equipo.serie
      vm.ticket.modelo     = equipo.modelo
      vm.ticket.descripcion     = equipo.descripcionArticulo
      vm.ticket.tipoEquipo = {
        codigo     : 99,
        descripcion: ''
        // codigo     : equipo.codigoTipoEquipo || '',
        // descripcion: equipo.descripcionTipoEquipo  || ''
      }
      vm.fetchFallas()
    },
    clearSerie () {
      var vm = this
      vm.ticket.serie          = ''
      vm.ticket.tipoEquipo = {}
      vm.fallas = []
    },
    fetchTiposEquipo () {
      var vm = this
      vm.isGettingTiposEquipo = true
      var obj = {}
      apiGet(vm, '/tipo_equipo/lista', obj, function (data) {
        // data.lista.pop();
        console.log('data.lista', data.lista)
        vm.tiposEquipo = data.lista
      }, function (error) {
        alert('error:' + error.message)
      }, function () {
        vm.isGettingTiposEquipo = false
      })
    },
    fetchUploadsFiles () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : `Adjuntando archivos al ticket` })
      vm.fileUploadRecursivo(0, err => {
        if (err) {
          notify(vm, 'error', 'Error', err.message)
          vm.$store.dispatch('transaccion', { isProceso : false })
          return
        }

        vm.files        = []
        vm.filesUploads = []
        notify(vm, 'success', 'Exito', 'El ticket se creo correctamente')
        vm.$store.dispatch('transaccion', { isProceso : false })
        vm.goTo(`/ticket/${vm.ticket.numero}`)
      })
    },
    fileUploadRecursivo (index, callback) {
      var vm = this
      vm.uploadFile(vm.files[index], async (err, response) => {
        if (err) {
          callback(err)
        } else {
          vm.fetchInsertarActividad(response, err => {
            if (err) callback(err)
            else {
              index++
              if (index === vm.files.length) callback(null)
              else vm.fileUploadRecursivo(index, callback)
            }
          })
        }
      })
    },
    fetchInsertarActividad (adjunto, callback) {
      var vm = this
      var obj = {
        numero       : vm.ticket.numero,
        tipo         : 'adjunto',
        contenido    : adjunto.ruta,
        nombreAdjunto: adjunto.archivo,
        tipoAdjunto  : adjunto.mimetype,
        noEnviarEmail: 1
      }

      apiPost(vm, '/ticket/registrar/actividad', obj, data => {
        callback && callback(null)
      }, error => {
        callback && callback(error)
      })
    },
    uploadFile (file, callback) {
      var vm = this
      var fd = new FormData()
      var apiUploadRoute = process.env.API_UPLOAD_ROUTE
      var url = `${apiUploadRoute}/upload`
      fd.append('file', file)
      var params = {
        carpeta: 'actividades',
        usuario: localStorage.getItem('usuario')
      }

      apiUploadWithParams(vm, url, fd, params,  res => {
        callback(null, res)
      }, err => {
        callback(err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.box-new-ticket
  max-height calc(100vh - 250px)
  min-height calc(100vh - 250px)
  overflow-y auto
</style>



// WEBPACK FOOTER //
// New_Ticket_View.vue?d49e2bea